import { render } from "./OnboardingProgressBar.vue?vue&type=template&id=f767646c&scoped=true"
import script from "./OnboardingProgressBar.vue?vue&type=script&lang=js"
export * from "./OnboardingProgressBar.vue?vue&type=script&lang=js"

import "./OnboardingProgressBar.vue?vue&type=style&index=0&id=f767646c&lang=postcss&scoped=true"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f767646c"]])

export default __exports__